"use strict";
export var InterfaceEventName = /* @__PURE__ */ ((InterfaceEventName2) => {
  InterfaceEventName2["ACCOUNT_DROPDOWN_BUTTON_CLICKED"] = "Account Dropdown Button Clicked";
  InterfaceEventName2["APPROVE_TOKEN_TXN_SUBMITTED"] = "Approve Token Transaction Submitted";
  InterfaceEventName2["CHAIN_CHANGED"] = "Chain Changed";
  InterfaceEventName2["CONNECT_WALLET_BUTTON_CLICKED"] = "Connect Wallet Button Clicked";
  InterfaceEventName2["EXPLORE_BANNER_CLICKED"] = "Explore Banner Clicked";
  InterfaceEventName2["EXPLORE_SEARCH_SELECTED"] = "Explore Search Selected";
  InterfaceEventName2["EXPLORE_TOKEN_ROW_CLICKED"] = "Explore Token Row Clicked";
  InterfaceEventName2["EXTERNAL_LINK_CLICK"] = "External Link Click";
  InterfaceEventName2["FIAT_ONRAMP_BANNER_CLICKED"] = "Fiat Onramp Banner Clicked";
  InterfaceEventName2["FIAT_ONRAMP_WIDGET_OPENED"] = "Fiat Onramp Widget Opened";
  InterfaceEventName2["LANGUAGE_SELECTED"] = "Language Selected";
  InterfaceEventName2["MINI_PORTFOLIO_TOGGLED"] = "Mini Portfolio Drawer Toggled";
  InterfaceEventName2["NAVBAR_RESULT_SELECTED"] = "Navbar Result Selected";
  InterfaceEventName2["NAVBAR_SEARCH_EXITED"] = "Navbar Search Exited";
  InterfaceEventName2["NAVBAR_SEARCH_SELECTED"] = "Navbar Search Selected";
  InterfaceEventName2["RISK_CHECKED"] = "Risk Checked";
  InterfaceEventName2["SEND_INITIATED"] = "Send Initiated";
  InterfaceEventName2["SEND_RECIPIENT_SELECTED"] = "Send Recipient Selected";
  InterfaceEventName2["TOKEN_IMPORTED"] = "Token Imported";
  InterfaceEventName2["TOKEN_SELECTED"] = "Token Selected";
  InterfaceEventName2["TOKEN_SELECTOR_OPENED"] = "Token Selector Opened";
  InterfaceEventName2["UNISWAP_WALLET_APP_DOWNLOAD_OPENED"] = "Uniswap Wallet App Download Opened";
  InterfaceEventName2["UNISWAP_WALLET_MICROSITE_OPENED"] = "Uniswap Wallet Microsite Opened";
  InterfaceEventName2["UNIWALLET_CONNECT_MODAL_OPENED"] = "Uniswap wallet modal opened";
  InterfaceEventName2["WALLET_CONNECTED"] = "Wallet Connected";
  InterfaceEventName2["WALLET_PROVIDER_USED"] = "Wallet Provider Used";
  InterfaceEventName2["WALLET_SELECTED"] = "Wallet Selected";
  InterfaceEventName2["WRAP_TOKEN_TXN_INVALIDATED"] = "Wrap Token Transaction Invalidated";
  InterfaceEventName2["WRAP_TOKEN_TXN_SUBMITTED"] = "Wrap Token Transaction Submitted";
  return InterfaceEventName2;
})(InterfaceEventName || {});
